import { Markdown } from '@components/shared/Markdown'
import { ProgramStep } from '@type/buzzkuri/program-detail'
import React from 'react'

type Props = {
  step: ProgramStep
  stepNum: number
}

export const StepItem = ({ step, stepNum }: Props): JSX.Element => {
  return (
    <div className="flex flex-col">
      <div className="flex flex-col lg:flex-row">
        <div className="flex flex-col justify-end lg:w-[18.2vw] lg:border-r-[3px] lg:border-[#F0B32F]">
          <div className="lg:mt-[3.7vw]">
            <div className="text-[2.9vw] lg:text-[1.1vw] font-bold text-[#333333]">
              STEP{stepNum + 1}
            </div>
          </div>
          <div className="lg:mb-[1vw]">
            <div className="lg:text-[1.4vw] font-bold lg:leading-[3vw] text-[#333333]">
              {step.title}
            </div>
          </div>
        </div>
        <div className="flex items-center lg:ml-[1.5vw] lg:w-[37.7vw]">
          <div className="lg:my-[1.6vw] mt-[3.8vw] mb-[4.2vw] lg:w-[29.7vw]">
            <Markdown
              classes="lg:text-[1.1vw] lg:leading-[2.3vw]"
              content={step.description}
            />
          </div>
        </div>
      </div>
      <div className="w-full h-[3px] bg-gradient-to-r from-primaryTo to-primaryFrom" />
    </div>
  )
}
